<template>
</template>

<script>
import { mapList, mapHiddenList , mapDSList, mapOperList } from '@/setting'
import { decodeAuth } from '@/plugins/common'

export default {
  name: 'base',
  data() {
    return {
      isOpenLang: false,
      isOpenSetting: false,
      // 刷新狀態
      refresh: false
    }
  },
  methods: {
    logout(msg = '') {
      localStorage.clear()
      this.$message({
        message: `Login Failed: ${msg}`,
        type: 'error'
      })
    },
    decodeAuth,
    /**
     * 設定網站標題
     */
    setDocumentTitle() {
      document.title = this.$ln('大廳')
    },
    /**
     * 開啟語系清單
     * @param val
     */
    getOpenLangStatus(val) {
      this.isOpenLang = val
      // 開關語系清單，關閉設定選單
      this.isOpenSetting = false
    },
    /**
     * logo icon
     */
    getLogoImgUrl() {
      // 不顯示
      const hidden = mapHiddenList
      const mapTable = mapList
      const mapDSTable = mapDSList
      const oper = localStorage.getItem('oper')
      console.log('oper', oper)

      // 沒有對應到視同無logo // 預設不顯示
      let url = ''

      // 有map到才顯示
      // const url = (mapTable.includes(oper)) ? `/icon/oper/${oper}/logo.png` : require('@/assets/img/DS_logo.png')
      // return (hidden.includes(oper)) ? '' : url

      // *** 改設定前專案圖片路徑，因此註解 ***//
      // switch (true) {
      //   case (mapTable.includes(oper)):
      //     // 雲端圖片路徑
      //     url = `/icon/oper/${oper}/logo.png`
      //     break
      //   case (mapDSTable.includes(oper)):
      //     url = require('@/assets/img/logo/DS_logo.png')
      //     break
      // }

      // 專案圖片路徑
      if (mapOperList[oper]) url = mapOperList[oper].logoPath

      return url
    },
    /**
     * 取得選中的語系
     * @param val
     */
    getLangSelected(val) {
      this.$store.commit('loading/LoadingStatusTrue') // 載入開始
      this.$i18n.locale = val.key
      localStorage.setItem('i18n', val.key)
      this.$store.dispatch('app/setLanguage', val.key)
      // console.log('this.$i18n.locale', this.$i18n.locale)
      this.getOpenLangStatus()
      this.setDocumentTitle()
      setTimeout(() => {
        this.$store.commit('loading/LoadingStatusFalse') // 載入結束
      }, 1000)
    },
    /**
     * 開啟設定選單
     * @param val
     */
    getOpenSettingStatus(val) {
      this.isOpenSetting = val
      // 開關設定選單，關閉語系清單
      this.isOpenLang = false
    },
    /**
     * 點選設定選單外關閉選單
     */
    closeSettingBlock() {
      this.isOpenSetting = false
    },
    /**
     * 點選語系選單外關閉選單
     */
    closeLangBlock() {
      this.isOpenLang = false
    },
    /**
     * 設定刷新狀態
     */
    refreshEffect() {
      this.refresh = false
      setTimeout(() => {
        this.refresh = true
      }, 10)
    },
    /**
     * 指定排序陣列資料
     * @param list 陣列資料
     * @param isCustomOrder 是否需要指定排序
     * @param customOrder 指定排序資料
     */
    sortArrayByOrder(list, isCustomOrder, customOrder) {
      if (!isCustomOrder) return list.slice() // 不指定回傳原本資料順序
      const orderMap = new Map()
      customOrder.forEach((id, index) => orderMap.set(id, index))
      return list.slice().sort((a, b) => {
        // 取得底線左側的 bannerXX，ex: "banner01_en_us.png" 取得 banner01
        const aKey = a.split('_')[0]
        const bKey = b.split('_')[0]
        const aOrder = orderMap.has(aKey) ? orderMap.get(aKey) : Infinity
        const bOrder = orderMap.has(bKey) ? orderMap.get(bKey) : Infinity
        return aOrder - bOrder
      })
    },
    /**
     * 轉換遊戲圖片語系
     */
    translationLang(lang) {
      // console.log('lang', lang)
      switch (lang) {
        case 'zh_cn':
          return 'cn'
        case 'zh_hk':
          return 'hk'
        case 'vi_vn':
          return 'vn'
        case 'th_th':
          return 'th'
        case 'ko_kr':
          return 'kr'
        case 'ja_jp':
          return 'ja'
        default: // 印尼文 id_id、葡萄牙文 pt_pt、西班牙文 es_es、英文 en_us，都顯示英文
          return 'en'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
